import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';
import { useCurrentSite } from '@hotjar/site';
import type { Site } from '@hotjar/site';
import type { GTMAccount, GTMContainer } from '@hotjar/webapp/domains/activation/gtm/model';
import { getContainers } from '@hotjar/webapp/domains/activation/gtm/api';

const CACHE_TIME = 10 * 1000; // 10 seconds

export const GTM_CONTAINERS = 'gtmContainers';

export const useGTMContainers = (
  gtmAccount?: GTMAccount,
): UseQueryResult<GTMContainer[], Error> => {
  const { data: currentSite } = useCurrentSite();
  const siteId = currentSite?.id;
  const accountId = gtmAccount?.accountId;

  return useQuery(
    [GTM_CONTAINERS, { siteId, accountId }],
    () => getContainers(currentSite as Site, gtmAccount as GTMAccount),
    {
      enabled: currentSite !== undefined && gtmAccount !== undefined,
      retry: false,
      staleTime: CACHE_TIME,
      cacheTime: CACHE_TIME,
    },
  );
};
